import { ContactsIcon } from 'foundations-assets';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { IconCircle } from 'foundations-components/transitional/components/IconCircle';
import { Link } from 'foundations-components/transitional/components/Link';
import { MediaObject } from 'foundations-components/transitional/components/MediaObject';
import { View } from 'foundations-components/transitional/components/View';
import FormattedMessage from 'I18n/components/FormattedMessage';

/**
 * Represents an account in a remote app.
 * To display "the name" of an account, check the following properties:
 *   (1) `accountName` (possibly empty)
 *   (2) `accountIdentifier`
 *
 * Specific examples:
 *  - Activecampaign:
 *      accountName = "daffyduck" + accountIdentifier = "daffy@syncduck.com (subdomain: daffyduck)" -> "daffyduck"
 *
 *  - Netsuite:
 *      accountName = "" + accountIdentifier = "4309538_SB1" -> "4309538_SB1"
 *  (Netsuite doesn't expose human readable account names)
 */
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function ConnectedAccount({
  portalId,
  appId,
  account,
  error
}) {
  return /*#__PURE__*/_jsx(View, {
    borderColor: "border-alert-default",
    borderWidth: "100",
    borderStyle: error ? 'solid' : 'none',
    children: /*#__PURE__*/_jsx(MediaObject, {
      "data-test-id": "universal-auth-account-avatar",
      paddingBlock: "400",
      paddingInline: "600",
      itemLeft: /*#__PURE__*/_jsx(IconCircle, {
        icon: ContactsIcon,
        color: "border-core-default",
        backgroundColor: "fill-primary-disabled",
        borderWidth: "0",
        size: "100"
      }),
      children: /*#__PURE__*/_jsxs(Flex, {
        justifyContent: "space-between",
        children: [/*#__PURE__*/_jsxs(View, {
          children: [/*#__PURE__*/_jsx(Text, {
            textTransform: "none",
            children: account.accountName
          }), account.accountIdentifier !== '' && /*#__PURE__*/_jsx(View, {
            children: /*#__PURE__*/_jsx(Text, {
              as: "small",
              use: "help",
              children: account.accountIdentifier
            })
          })]
        }), error && portalId && appId && /*#__PURE__*/_jsx(Flex, {
          alignItems: "center",
          children: /*#__PURE__*/_jsx(Link, {
            href: `/data-sync/${portalId}/app/${appId}/account/${account.id}`,
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "universalAuth.auth.viewAccountSettings"
            })
          })
        })]
      })
    })
  });
}